<mat-form-field>
  <mat-label>{{ label }}</mat-label>
  <input matInput id="date-text-box" type="text" placeholder="MM/DD/YYYY"
    [(ngModel)]="display_value" (blur)="handleChange()"
    [disabled]="is_disabled" mask="00/00/0000" [dropSpecialCharacters]="false" />
</mat-form-field>
